<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const props = withDefaults(defineProps<{ label?: string; spelareId?: string }>(), { label: "Idrott" });

    const store = useStore();

    // Formulärvarianten: option-värdet är idrottens id (matchar FK-fältet idrott, t.ex. i FormLag).
    const fetchIdrott = async ({ query }: { query?: string } = {}) => {
        try {
            const params: { namn?: string; spelare?: string } = {};
            if (query) params.namn = query;
            if (props.spelareId) params.spelare = props.spelareId;

            const { subsetName } = await store.dispatch("skreg/idrott/fetchIdrott", { filterParams: params });
            const items = store.getters["skreg/idrott/idrottSubset"]({ subsetName, limit: 0 });

            return items.map((idrott: { id: string; namn: string }) => ({ value: idrott.id, label: idrott.namn }));
        } catch {
            flashWarning("Kunde inte hämta idrotter");
        }
    };
</script>

<template>
    <KAutocomplete
        name="idrott"
        :label="label"
        v-bind="$attrs"
        v-on="$listeners"
        :options="fetchIdrott"
        :onSearch="fetchIdrott"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
